import React, { useCallback } from "react";

import { useStoredDataDispatch } from "@/store";
import { SupCog } from "@repo/core-ui";

export default function GridHeaderCellApy() {
  const storedDispatch = useStoredDataDispatch();

  const handleRewards = useCallback(
    (e: any) => {
      e.stopPropagation();
      storedDispatch({ type: "setOverlay", overlay: "rewards-apy" });
    },
    [storedDispatch]
  );

  return (
    <div className="flex space-x-1">
      <div className="overflow-hidden text-ellipsis whitespace-nowrap font-mono text-base font-normal uppercase leading-none tracking-normal antialiased">30D APY</div>
      <SupCog className="h-4 w-4 text-neutral-500" onClickCapture={handleRewards} />
    </div>
  );
}
